export const isMicroApp = !!window.__POWERED_BY_QIANKUN__
export const isDev = process.env.NODE_ENV !== 'production'
export const isTestEnv = process.env.VUE_APP_bmEnv !== 'prod'
export const projectId = 'agency'

export const miniAppUrlMap = {
  1: 'https://miniapp.tanchi0757.shop', // 贪吃taste
  1688: 'http://miniapp.boomsj.com', // 贪吃商品
  2: 'https://miniapp.egg.tanchi0757.shop', // 吃团团egg
  1888: 'https://miniapp.egg.tanchi.shop', // 吃团团
  7: 'https://miniapp.travel.tanchi0757.shop', // 贪吃酒旅test
  1999: 'https://miniapp.travel.tanchi.shop' // 贪吃酒旅
}
